import React, { Fragment, useState } from "react";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import { Submenu } from "../../typings/Submenu";
import { MenuItem } from "./MenuItem";

interface MultilevelProps {
  item: Submenu;
  handleSubitemClick: (item: Submenu) => void;
  selectedItem?: string | null;
  onSelectItem?: (id: string) => void;
}

export const MultiLevel: React.FC<MultilevelProps> = ({
  item,
  handleSubitemClick,
  selectedItem,
  onSelectItem
}) => {
  const { items } = item;
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  return (
    <Fragment>
      <ListItemButton onClick={handleClick} selected={selectedItem === item.url}>
        <ListItemIcon style={{ alignItems: "flex-start" }}></ListItemIcon>
        <ListItemText
          primary={item.name}
          primaryTypographyProps={{
            style: { fontWeight: 900 },
          }}
        />
        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </ListItemButton>
      <Collapse in={open} timeout="auto">
        <List component="div" disablePadding>
          {items !== undefined &&
            items.map((child: Submenu, key) => {
              return (
                <MenuItem
                  key={key}
                  submenu={child}
                  handleSubitemClick={() => handleSubitemClick(child)}
                  selectedItem={selectedItem}
                  onSelectItem={onSelectItem}
                />
              );
            })}
        </List>
      </Collapse>
    </Fragment>
  );
};
